import {useEffect, useState} from 'react';
import axios from "axios"
import Nav from "../Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import * as XLSX from "xlsx";
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import L from 'leaflet';
import {MapContainer, TileLayer, Marker, Popup, useMap} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';


import icon from 'leaflet/dist/images/marker-icon.png';
import wfo_icon from '../../img/wfo.svg';
import hts_icon from '../../img/hts.svg';
import aud_icon from '../../img/aud.svg';
import ittlp_icon from '../../img/ittlp.svg';
import wtl_icon from '../../img/wtl.svg';
import wtt_icon from '../../img/wtt.svg';
import wtu_icon from '../../img/wtu.svg';
import ittop_icon from '../../img/ittop.svg';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import {Map} from "leaflet/dist/leaflet-src.esm";

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow
});

let wfo = L.icon({
    iconUrl: wfo_icon,
    iconSize: [25, 25]
});
let hts = L.icon({
    iconUrl: hts_icon,
    iconSize: [25, 25]
});
let ittop = L.icon({
    iconUrl: ittop_icon,
    iconSize: [25, 25]
});

let aud = L.icon({
    iconUrl: aud_icon,
    iconSize: [25, 25]
});

let ittlp = L.icon({
    iconUrl: ittlp_icon,
    iconSize: [25, 25]
});
let wtl = L.icon({
    iconUrl: wtl_icon,
    iconSize: [25, 25]
});
let wtt = L.icon({
    iconUrl: wtt_icon,
    iconSize: [25, 25]
});
let wtu = L.icon({
    iconUrl: wtu_icon,
    iconSize: [25, 25]
});

L.Marker.prototype.options.icon = DefaultIcon;

let source = axios.CancelToken.source();
function iniState() {
    return (
        {
            objs: [],
            datas: [],
            objsl: false,
            lat: 9.5666316,
            lon: 41.86226,
            zoom: 6,
            search:'',
        }
    )
}
function Screen_2 () {
    const [state,setState]=useState(()=>iniState())
    function points() {
        let retdata = null;
        if (state.objsl) {
            retdata = state.datas.map(v => {
                if (v.checked) {
                    let pu = <Popup>
                        <div className="card">
                            <div className="card-header">
                                <h2>{v.plate_no}</h2>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold  px-0 py-2 m-0">Truck: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p className="px-0 py-2 m-0">{v.plate_no}</p>
                                    </div>
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold px-0 py-2 m-0">Status: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p className="px-0 py-2 m-0">{v.type}</p>
                                    </div>
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold px-0 py-2 m-0">Location: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p title={v.long_name} className="px-0 py-2 m-0">{v.avlloc}</p>
                                    </div>
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold px-0 py-2 m-0">Update Time: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p className="px-0 py-2 m-0">{v.avltime}</p>
                                    </div>
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold px-0 py-2 m-0">Km Left: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p className="px-0 py-2 m-0">{v.km}</p>
                                    </div>
                                    <div className="col-4 p-0 m-0">
                                        <p className="text-bold px-0 py-2 m-0">Route: </p>
                                    </div>
                                    <div className="col-8 p-0 m-0">
                                        <p className="px-0 py-2 m-0">{v.start_at}/{v.end_at}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="card-footer p-0">
                                <ul className="nav flex-column">
                                    <li className="nav-item">
                                        <a href className="nav-link">{v.type}</a></li>
                                </ul>
                            </div>
                        </div>
                    </Popup>

                    if (v.type == "WAITING_FOR_ORDER")
                        return (
                            <Marker
                                key={v.id}
                                position={[
                                    v.lat,
                                    v.lon
                                ]}
                                icon={wfo}
                            >
                                {pu}
                            </Marker>)
                    else if (v.type == "HEADING_TO_STATION")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={hts}
                        >
                            {pu}
                        </Marker>)
                    else if (v.type == "ALLOCATED_UNDER_DISPATCH")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={aud}
                        >
                            {pu}
                        </Marker>)
                    else if (v.type == "ALLOCATED_UNDER_DISPATCH")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={aud}
                        >
                            {pu}
                        </Marker>)
                    else if (v.type == "IN_TRANSIT_TO_LOAD_POINT")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={ittlp}
                        >{pu}</Marker>)
                    else if (v.type == "WAITING_TO_LOAD")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={wtl}
                        >{pu}</Marker>)
                    else if (v.type == "WAITING_TO_TRANSIT")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={wtt}
                        >{pu}</Marker>)
                    else if (v.type == "IN_TRANSIT_TO_OFFLOAD_POINT")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={ittlp}
                        >{pu}</Marker>)
                    else if (v.type == "WAITING_TO_OFFLOAD")
                        return (<Marker
                            key={v.id}
                            position={[
                                v.lat,
                                v.lon
                            ]}
                            icon={wtu}
                        >{pu}</Marker>)
                }
            })
        }
        return <>{retdata}</>
    }
    function inputmgt_Checkbox(event){
        if (state.objsl) {
            var name = event.target.name;
            var temp = state.datas;
            var lat="9.5666316";
            var lon="41.86226";
            var zoom=6;
            temp = temp.map(v => {
                if (v.id == name) {
                    if(v.checked){
                        v.checked = false;
                        zoom = 6;
                    }
                    else
                    {
                        v.checked = true;
                        lat = v.lat;
                        lon = v.lon;
                        zoom = 14;

                    }
                }
                return v;
            })
            setState(prvstate=>{
                return(
                    {
                        ...prvstate,
                        datas: temp,
                        lat:lat,
                        lon:lon,
                        zoom:zoom,

                    }
                )
            })
        }
    }
    function inputmgt_search(event){
        if (state.objsl) {
            var name = event.target.name;
            var value = event.target.value;
            var temp = state.objs.retdatas;
            var lat="9.5666316";
            var lon="41.86226";
            var zoom=6;
            var isset=false;
            if(value!=""){
                var temp2=temp.filter(v=>{
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        if(!isset){
                             lat=v.lat;
                             lon=v.lon;
                             zoom=13;
                             isset=true;
                        }
                        return value;
                    }
                })
                temp=temp2;
            }

            setState(prvstate=>{
                return(
                    {
                        ...prvstate,
                        datas: temp,
                        lat:lat,
                        lon:lon,
                        zoom:zoom,
                        search:value,
                    }
                )
            })
        }
    }
    useEffect(()=>{
        async function fetchdata() {
            let baseurl = myconfig.get_screen_2;
            let redirecttologin = myconfig.redirecttologin;
            await axios.post(baseurl, {
                sid: window.localStorage.getItem("ntfms_sid"),
            }, {cancelToken: source.token}).then(res => {
                console.log(res.data)
                if (res.data.auth == false) {
                    window.localStorage.setItem("ntfms_sid", null);
                    window.localStorage.setItem("ntfms_username", null);
                    window.localStorage.setItem("ntfms_name", null);
                    var win = window.open(redirecttologin, "_self");
                } else if (res.data.success == false) {
                    Swal.fire({
                        title: 'Error!',
                        text: res.data.msg,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                } else {
                    setState(prvstate => {
                        return {
                            ...prvstate,
                            objs: res.data,
                            datas: res.data.retdatas,
                            objsl: true,
                            lat: 9.5666316,
                            lon: 41.86226,
                            zoom: 6,
                        }
                    })
                }
            }).catch((e) => {
                console.log(e.message);
            });
        }
        fetchdata()
    },[])
    function left_menu(){
        let retdata = null;
        if (state.objsl) {
            let datas = state.datas.map(v => {
                let checked=false;
                if(v.checked)
                    checked=true;
                return (
                    <>
                        <div className="col-1 pt-2">
                            <input type="checkbox" onClick={inputmgt_Checkbox} checked={checked} name={v.id} id="todoCheck1"/>
                        </div>
                        <div className="col-5 pt-2">
                            <label htmlFor="todoCheck1">{v.plate_no}</label>
                        </div>
                        <div className="col-6 pt-2">
                            <p>{v.avlloc}</p>
                        </div>
                    </>
                )
            })
            retdata= <>
                <div className="card">
                    <div className="card-header ui-sortable-handle" style={{cursor: 'move'}}>
                        <h3 className="card-title">
                            <i className="ion ion-clipboard mr-1"/>
                            Vehicle List
                        </h3>
                    </div>
                    <div className="card-header ui-sortable-handle" style={{cursor: 'move'}}>
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <input className="form-control" placeholder="Search" name="search" value={state.search} onChange={inputmgt_search}/>
                                </div>
                            </div>
                            <div className="col-5">
                                <p className="text-bold">Truck</p>
                            </div>
                            <div className="col-6">
                                <p className="text-bold">Location</p>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            {datas}
                        </div>
                    </div>
                </div>
            </>
        }
        return <>{retdata}</>
    }
    function MyComponent() {
        const map = useMap()
        map.setView(
            [
                state.lat,
                state.lon
            ],
            state.zoom
        )
        return null;
    }
    return (
        <div className="row">
            <div className="col-md-3 table-responsive" style={{height:"100vh"}}>
                {left_menu()}
            </div>
            <div className="col-md-9">
                <MapContainer center={[state.lat, state.lon]} zoom={state.zoom} >
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    {points()}
                    <MyComponent/>
                </MapContainer>
            </div>
        </div>
    )
}

export default Screen_2;
